export default class ComponentHelper {
	static deleteAllVsNotifications() {
		const alerts = document.querySelectorAll(".vs-notifications");
		if (alerts) {
			alerts.forEach(alert => alert.parentNode.removeChild(alert));
		}
	}
}
